import { ChangeEvent, useContext, useState, useEffect } from "react";
import styled from "styled-components";
import { IconWithText } from "../models/post";
// @ts-ignore
import { CKEditor } from '@ckeditor/ckeditor5-react';
// @ts-ignore
import BalloonEditor from '@ckeditor/ckeditor5-build-balloon';
import Modal from "../components/modal";
import FirebaseContext from "../utils/firebase-context";
import { nanoid } from "nanoid";
import PrimaryButton from "../components/primary-button";
import { DeleteButton } from "./text-component";
import { AddRounded, CloseRounded } from "@mui/icons-material";

const Grid = styled.div`
  display: grid;
  gap: 1rem;
  grid-template-columns: 3fr 7fr;
`;

const Icon = styled.div`
	position: relative;
	width: 150px;
	height: 150px;
	margin: auto;
	border-radius: 50%;
	overflow: hidden;
	cursor: pointer;
	&:hover {
		&::after {
			background: rgba(0,0,0,0.2);
		}
	}
	&::after {
		border-radius: 50%;
		transition: .1s;
		position: absolute;
		content: '';
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: transparent;
	}
	img {
		width: 100%;
		object-fit: cover;
	}
`;

const AddButton = styled.div`
	height: 100%;
	width: 100%;
	background: #EEEEEE;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 4rem;
	color: #8d8d8d;
	cursor: pointer;
	border-radius: 50%;
	transition: .1s;
	&:hover {
		background: #d8d8d8;
	}
`;

function Placeholder() {
	return <AddButton>
		<AddRounded />
	</AddButton>
}

const Picker = styled.div`
	position: relative;
  height: 150px;
  min-width: 150px;
  cursor: pointer;
  border-radius: 50%;
  background: #EEEEEE;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #CCCCCC;
  font-size: 4rem;
  transition: .1s;
  &:hover {
    color: #BBBBBB;
  }
	img {
    height: 100%;
    width: 100%;
		object-fit: cover;
  }
`;

const Input = styled.input`
  display: none;
`;
const Label = styled.label`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  border-radius: 12px;
  cursor: pointer;
`;

function PreviewImage(props: { file: File }) {
	return <img src={URL.createObjectURL(props.file)} alt="Preview" />
}

function ChangeIconModal(props: {
	close: () => void;
	updateImage: (src: string) => void;
}) {
	const { updateImage } = props;
	const [img, setImg] = useState<File>();
	const [loading, setLoading] = useState(false);

	const firebase = useContext(FirebaseContext);

	const updateImagePicker = (e: ChangeEvent<HTMLInputElement>) => {
		const files = e.target.files;
		if (!files || !files[0]) return;
		setImg(files[0]);
	};

	const changeImage = async () => {
		const id = nanoid(12);
		if (!img) return;

		setLoading(true);
		const task = await firebase.storage.ref("blog_icon/" + id).put(img);
		const src = await task.ref.getDownloadURL();
		updateImage(src);
		props.close();
	}

	return <Modal title="Icon ändern" close={props.close}>
		{loading ? <div>Änderungen werden vorgenommen...</div> : <>
			<div style={{
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				marginBottom: "1rem",
			}}>
				<Picker>
					{!img ? <AddRounded /> : <PreviewImage file={img} />}
					<Input type="file" id={`file-input`} onChange={updateImagePicker} accept={"image/*"} />
					<Label htmlFor={`file-input`} />
				</Picker>
			</div>
			<PrimaryButton onClick={changeImage} disabled={!img}>
				Bild hochladen
			</PrimaryButton>
		</>
		}
	</Modal>
}

export function IconTextComponent(props: {
	iconWithText: IconWithText;
	update: (icon: string, text: string) => void;
	deleteContent: () => void;
}) {
	const [icon, setIcon] = useState(props.iconWithText.icon);
	const [text, setText] = useState(props.iconWithText.text);

	const [showModal, setShowModal] = useState(false);
	const [showDelete, setShowDelete] = useState(false);

	const onChange = (_event: any, editor: { getData: any; }) => {
		setText(editor.getData());
	};

	useEffect(() => {
		props.update(icon, text);
	}, [icon, text, props]);

	return <>
		<Grid>
			<Icon onClick={() => setShowModal(true)}>
				{icon === "" ? <Placeholder /> : <img src={icon} alt="Icon" />}
			</Icon>
			<div>
				<div onMouseMove={() => setShowDelete(true)} onMouseEnter={() => setShowDelete(true)} onMouseLeave={() => setShowDelete(false)} style={{
					position: "relative"
				}}>
					<CKEditor editor={BalloonEditor} data={text} config={{
						toolbar: ['heading', 'bold', 'italic', 'link', '|', 'bulletedList', 'numberedList', '|', 'undo', 'redo'],
						placeholder: "Text schreiben..."
					}} onChange={onChange} />
					<DeleteButton show={showDelete} onClick={props.deleteContent}>
						<CloseRounded />
					</DeleteButton>
				</div>
			</div>
		</Grid>
		{showModal && <ChangeIconModal
			close={() => setShowModal(false)}
			updateImage={(src: string) => {
				setIcon(src);
			}}
		/>}
	</>;
}
